<template>
    <div>
        <Form
            :countries="countries"
            :states="states"
            :phone-country-code-placeholder="phoneCountryCodePlaceholder"
            :company-sanities="companySanities"
            :brands="brands"
            :titles="titles"
            :customer-types="customerTypes"
            :payment-terms="paymentTerms"
            :payment-methods="paymentMethods"
            :tax-exemptions="taxExemptions"
            :billing-types="billingTypes"
            :customer-segments="customerSegments"
            :invoice-aggregations="invoiceAggregations"
            :invoice-delivery-types="invoiceDeliveryTypes"
            :electronic-invoicing-types="electronicInvoicingTypes"
            :errors="errors"
            :default-brand="defaultBrand"
            :use-herold-location-id-on-customer="useHeroldLocationIdOnCustomer"
            :ssn-business-id="ssnBusinessId"
            :customer="customer"
            :order-no="orderNo"
            :legal-forms="legalForms"
            :original-brands="originalBrands"
            :communication-subscriptions="communicationSubscriptions"
            :active-communication-subscriptions="activeCommunicationSubscriptions"
            :communication-subscriptions-approved="communicationSubscriptionsApproved"
            :is-finance-system-netsuite="isFinanceSystemNetsuite"
            :market-region-options="marketRegionOptions"
            :default-market-region="defaultMarketRegion"
            @form-submitted="submitData"
            @tax-exemption-fetch="getTaxExemptions"
        />
        <PossibleTaxExemptions
            :show-modal="showTaxExemptionModal"
            :tax-exemptions="possibleTaxExemptionsString"
            @close-modal="closeModal"
            @confirm-modal="submitForm"
        />
    </div>
</template>

<script>
import Form from '~@/Components/Customers/Customers/Form'

import PossibleTaxExemptions from '~@/Components/Customers/Customers/Modals/PossibleTaxExemptions.vue'

export default {
    name: 'CustomerCreate',
    components: {
        PossibleTaxExemptions,
        Form
    },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        countries: {
            type: Array,
            default: () => { return [] }
        },
        states: {
            type: Object,
            default: () => { return {} }
        },
        phoneCountryCodePlaceholder: {
            type: String,
            default: '+49'
        },
        companySanities: {
            type: Array,
            default: () => { return [] }
        },
        brands: {
            type: Array,
            default: () => { return [] }
        },
        titles: {
            type: Array,
            default: () => { return [] }
        },
        customerTypes: {
            type: Array,
            default: () => { return [] }
        },
        paymentTerms: {
            type: Array,
            default: () => { return [] }
        },
        paymentMethods: {
            type: Array,
            default: () => { return [] }
        },
        taxExemptions: {
            type: Array,
            default: () => { return [] }
        },
        billingTypes: {
            type: Array,
            default: () => { return [] }
        },
        customerSegments: {
            type: Array,
            default: () => { return [] }
        },
        invoiceAggregations: {
            type: Array,
            default: () => { return [] }
        },
        defaultBrand: {
            type: Number,
            default: 1
        },
        invoiceDeliveryTypes: {
            type: Array,
            default: () => { return [] }
        },
        electronicInvoicingTypes: {
            type: Array,
            default: () => { return [] }
        },
        useHeroldLocationIdOnCustomer: {
            type: Boolean,
            default: () => { return false }
        },
        ssnBusinessId: {
            type: Boolean,
            default: () => { return false }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        },
        orderNo: {
            type: String,
            default: () => { return '' }
        },
        legalForms: {
            type: Array,
            default: () => { return [] }
        },
        originalBrands: {
            type: Array,
            default: () => { return [] }
        },
        communicationSubscriptions: {
            type: Array,
            default: () => { return [] }
        },
        activeCommunicationSubscriptions: {
            type: Array,
            default: () => { return [] }
        },
        communicationSubscriptionsApproved: {
            type: Boolean,
            default: false
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: false
        },
        marketRegionOptions: {
            type: Array,
            default: () => { return [] }
        },
        defaultMarketRegion: {
            type: Number,
            default: () => { return 1 }
        }
    },
    data () {
        return {
            showTaxExemptionModal: false,
            possibleTaxExemptions: [],
            formData: {}
        }
    },
    computed: {
        possibleTaxExemptionsString () {
            return this.possibleTaxExemptions.join(', ')
        }
    },
    methods: {
        submitData (event) {
            this.formData = event.form
            if (this.possibleTaxExemptions.length > 0) {
                this.showTaxExemptionModal = true
            } else {
                this.submitForm()
            }
        },
        async getTaxExemptions (form) {
            await window.axios.get(this.$route(
                'settings.tax-exemption.customer-check',
                {
                    city: form.invoice_city ?? form.city,
                    country: (form.use_alternative_billing && form.invoice_country_code) ? form.invoice_country_code : form.country_code,
                    company: form.invoice_company ?? form.company
                }))
                .then(response => {
                    this.possibleTaxExemptions = response.data
                })
        },
        closeModal () {
            this.showTaxExemptionModal = false
        },
        submitForm () {
            this.closeModal()
            this.formData.post(this.$route('customers.customers.store'))
        }
    }
}
</script>
